
"use client";

import Interstitial from '@/components/interstitial';
import { useContext, useEffect, useMemo, useRef } from 'react';
import LayoutHead from '@/components/layout-head';
import styles from './_hcp-layout-full.module.scss';
import HcpHeader from '@/components-hcp/header';
import HcpIsi from '@/components-hcp/isi';
import FooterFull from '@/layouts/components/footer';
import Tooltip from '@/components/tooltip';
import { LayoutContext } from '@/components/layout-context-container';
import CookiePolicy from '@/components/cookie-policy';
import Button from '@/components/button';
import StickyHeader from '@/components/sticky-header';
import IndicationsTray from '@/components/indications-tray';
import BackToTop from '@/components-hcp/back-to-top';

export default function HcpLayoutFull({
  meta,
  customClass = undefined,
  isiDisabled = false,
  hero = null,
  navDisabled = false,
  navDisabledLogoCentered = false,
  children
}) {
  const containerRef = useRef(null);
  const fixedTopRef = useRef(null);
  const { tooltipRef } = useContext(LayoutContext);
  const { 
    title = '',
    footer = {
      code: <>CP-CFT-US-0263v4 11/2025&nbsp; <br className="mobile:hidden" />CP-CFT-US-1003 07/2026</>,
      codeDate: <></>,
      codeYear: <>2026</>
    },
    metadata = undefined,
    link = undefined,
    schemaTag = undefined,
  } = meta || {};

  const containerClass = useMemo(() => {
    var className = `hcp-layout-full ${styles.container}`;

    if (customClass) {
      className = `${className} ${customClass}`;
    }

    return className;
  }, [customClass]);

  useEffect(() => {
    function handleResize() {
      containerRef.current?.style.setProperty('--fixed-top-height', `${fixedTopRef.current?.clientHeight}px`);

      const homeConferenceBanner = document.querySelector('.home-conference-banner:not(.home-conference-banner--hidden)');
      containerRef.current?.style.setProperty('--home-conference-banner-height', `${homeConferenceBanner?.clientHeight || 0}px`);
    }

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <StickyHeader fixedTopRef={fixedTopRef} isHCP={true}>
        <div className={`hcp-layout-full__fixed-top ${styles.fixed_top}`} ref={fixedTopRef}>
          {/* <CookiePolicy isHcp>
            By continuing to use this site, you agree to our use of cookies as described in our <Button targetBlank={true} href="https://www.neurocrine.com/cookie-policy/">Cookie Policy</Button>.
          </CookiePolicy> */}
          <IndicationsTray
            fullContent ={<>
              <strong className="text-hcp-eggplant">INDICATION</strong> CRENESSITY (crinecerfont) is indicated as adjunctive treatment to glucocorticoid replacement to control androgens in adults and pediatric patients 4 years of age and older with classic congenital adrenal hyperplasia (CAH).
            </>}
            shortContent ={<>
              <strong className="text-hcp-eggplant">INDICATION</strong> CRENESSITY (crinecerfont) is indicated as adjunctive treatment to glucocorticoid replacement to control androgens...
            </>}
          ></IndicationsTray>
        </div>
        <HcpHeader navDisabled={navDisabled} navDisabledLogoCentered={navDisabledLogoCentered} isSticky={true} />
      </StickyHeader>
      <LayoutHead
        title={title}
        metadata={metadata}
        link={link}
        schemaTag={schemaTag}
      />
      <div className={containerClass} ref={containerRef}>
        <div className={styles.header_wrapper}>
          {/* <HcpHeader navDisabled={navDisabled} navDisabledLogoCentered={navDisabledLogoCentered} /> */}
          {hero}
        </div>
        <main>
          <div>
            {children}
          </div>
          {!isiDisabled && <HcpIsi />}
        </main>
        <Tooltip ref={tooltipRef} />
        <Interstitial />
        <BackToTop />
        <FooterFull code={footer?.code} codeDate={footer?.codeDate} codeYear={footer?.codeYear} />
      </div>
    </>
  );
}